import React from 'react';

const AppContext = React.createContext({
    headless: false,
    path: '/',
    filter: false,
    subscriptionUrl: '',
    monitoring_url: false
})
export default AppContext